import {
    type UpdatePresidentResponseType,
    type UpdatePresidentRequestType
} from "./type";
import {
    request
} from "../request";

const updatePresident = async (params: UpdatePresidentRequestType): Promise<UpdatePresidentResponseType> => {
    return await request<UpdatePresidentResponseType>("/content/updatePresident", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default updatePresident;
